import { useCallback } from "react"
import { createModel } from "hox"
import { useSetState } from "@/reactUse"
import { getBoards } from "@/api/board"

type Board = {
  id: string
  name: string
  type: string
  source: number
  userName: string
  updateUser: string
  updateTime: number
  data: string
  created_at: string
}

type State = {
  boardList: Board[]
  current_board_id: string
}

function useDashBoard() {
  const [state, set] = useSetState<State>({
    boardList: [],
    current_board_id: "",
  })

  const auquireBoardList = useCallback(async () => {
    const result = await getBoards()
    if (!result) {
      return
    }
    set({ boardList: result.items })
  }, [set])

  const modifyId = useCallback(
    (id: string) => {
      set({ current_board_id: id })
    },
    [set]
  )

  return {
    ...state,
    auquireBoardList,
    modifyId,
  }
}

export default createModel(useDashBoard)
